type BillingType = "credit" | "usage-arrears";

interface CreateInstanceBillingGateParams {
  billingType?: BillingType;
  currentBalance: number;
  noCardOnFile: boolean;
  isBrevCloud: boolean;
  isComputeFree: boolean;
  isStorageFree: boolean;
}

export const shouldShowCreateInstanceBillingModal = ({
  billingType,
  currentBalance,
  noCardOnFile,
  isBrevCloud,
  isComputeFree,
  isStorageFree,
}: CreateInstanceBillingGateParams): boolean => {
  if (!isBrevCloud || (isComputeFree && isStorageFree)) {
    return false;
  }

  if (billingType === "usage-arrears") {
    return noCardOnFile;
  }

  if (billingType === "credit") {
    return currentBalance <= 0;
  }

  return false;
};
